import { useCallback, useState } from "react";
import {
  Table,
  Badge,
  Collapse,
  ActionIcon,
  NumberFormatter,
} from "@mantine/core";
import { IconChevronDown, IconChevronRight } from "@tabler/icons-react";
import type { CptByPracticeRow } from "../../services/reports.service";

export interface PracticeRowProps {
  practice: CptByPracticeRow;
}

export function PracticeRow({ practice }: PracticeRowProps) {
  const [expanded, setExpanded] = useState(false);

  const handleToggleExpand = useCallback(() => {
    setExpanded((v) => !v);
  }, []);

  return (
    <>
      <Table.Tr style={{ cursor: "pointer" }} onClick={handleToggleExpand}>
        <Table.Td>
          <ActionIcon size="xs" variant="subtle" color="gray">
            {expanded ? (
              <IconChevronDown size={14} />
            ) : (
              <IconChevronRight size={14} />
            )}
          </ActionIcon>
        </Table.Td>
        <Table.Td fw={500}>{practice.practiceName}</Table.Td>
        <Table.Td>{practice.totalCptCount}</Table.Td>
      </Table.Tr>
      <Table.Tr>
        <Table.Td colSpan={3} p={0}>
          <Collapse in={expanded}>
            <Table withTableBorder={false} style={{ marginLeft: 32 }}>
              <Table.Thead>
                <Table.Tr>
                  <Table.Th>Code</Table.Th>
                  <Table.Th>Description</Table.Th>
                  <Table.Th>Count</Table.Th>
                  <Table.Th>Unit Fee</Table.Th>
                  <Table.Th>Total Fee</Table.Th>
                </Table.Tr>
              </Table.Thead>
              <Table.Tbody>
                {practice.breakdown.map((row) => (
                  <Table.Tr key={row.cptCodeId}>
                    <Table.Td>
                      <Badge variant="outline" size="sm">
                        {row.cptCode}
                      </Badge>
                    </Table.Td>
                    <Table.Td>{row.description}</Table.Td>
                    <Table.Td>{row.count}</Table.Td>
                    <Table.Td>
                      {row.unitFee != null ? (
                        <NumberFormatter
                          value={row.unitFee}
                          prefix="$"
                          decimalScale={2}
                        />
                      ) : (
                        "—"
                      )}
                    </Table.Td>
                    <Table.Td>
                      {row.totalFee != null ? (
                        <NumberFormatter
                          value={row.totalFee}
                          prefix="$"
                          decimalScale={2}
                        />
                      ) : (
                        "—"
                      )}
                    </Table.Td>
                  </Table.Tr>
                ))}
              </Table.Tbody>
            </Table>
          </Collapse>
        </Table.Td>
      </Table.Tr>
    </>
  );
}
